type CurrencyOptions = {
  currency?: string;
  decimals?: number;
  groupSeparator?: string;
  decimalSeparator?: string;
};

export const formatCurrency = (
  amount: number | string | undefined,
  options: CurrencyOptions = {},
): string => {
  const {
    currency = '$',
    decimals = 2,
    groupSeparator = ',',
    decimalSeparator = '.',
  } = options;

  let numericAmount: number | undefined;

  if (typeof amount === 'string') {
    const cleanAmount = amount.replace(/[^0-9.-]/g, '');
    numericAmount = Number(cleanAmount);
  } else {
    numericAmount = amount;
  }

  if (
    Number.isNaN(numericAmount) ||
    !Number.isFinite(numericAmount) ||
    typeof numericAmount !== 'number'
  ) {
    throw new Error('Invalid amount provided');
  }

  const [integerPart, fractionPart = ''] = Math.abs(numericAmount)
    .toFixed(decimals)
    .split('.');
  const formattedIntegerPart = integerPart
    .split('')
    .reverse()
    .reduce((acc, digit, index) => {
      const shouldAddSeparator = index > 0 && index % 3 === 0;
      return shouldAddSeparator
        ? `${digit}${groupSeparator}${acc}`
        : `${digit}${acc}`;
    }, '');

  const sign = numericAmount < 0 ? '-' : '';
  const formattedAmount = fractionPart
    ? `${formattedIntegerPart}${decimalSeparator}${fractionPart}`
    : formattedIntegerPart;

  return `${sign}${currency}${formattedAmount}`;
};
